export default __webpack_public_path__ + "static/media/banner-01.30964574.jpg";